import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 706 433"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "706",
      height: "433",
      fill: "var(--colorWidgetBackground-color)",
      rx: "6"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--primary-color)",
      d: "M266 319.353 123 67h461L439.364 319.353V403H266z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--mainTextColor-color)",
      d: "M306.859 225v-14h2.68l8.26 10.08h-1.3V211h3.2v14h-2.66l-8.28-10.08h1.3V225zm22.953.24q-1.66 0-3.08-.54a7.4 7.4 0 0 1-2.44-1.52 7.1 7.1 0 0 1-1.6-2.3q-.56-1.32-.56-2.88t.56-2.88a7 7 0 0 1 1.62-2.3 7.4 7.4 0 0 1 2.44-1.52q1.4-.54 3.04-.54 1.66 0 3.04.54 1.4.54 2.42 1.52a7 7 0 0 1 1.62 2.3q.58 1.3.58 2.88 0 1.56-.58 2.9a7 7 0 0 1-1.62 2.3 7.35 7.35 0 0 1-2.42 1.5q-1.38.54-3.02.54m-.02-2.76q.94 0 1.72-.32.8-.32 1.4-.92t.92-1.42a4.7 4.7 0 0 0 .34-1.82 4.7 4.7 0 0 0-.34-1.82 4.1 4.1 0 0 0-.92-1.42 3.9 3.9 0 0 0-1.38-.92 4.7 4.7 0 0 0-1.74-.32q-.94 0-1.74.32-.78.32-1.38.92t-.94 1.42a5 5 0 0 0-.32 1.82q0 .98.32 1.82.34.82.92 1.42.6.6 1.4.92t1.74.32m15.759 2.52v-14h6.36q2.28 0 4.02.88 1.74.86 2.72 2.42t.98 3.7q0 2.12-.98 3.7-.98 1.56-2.72 2.44-1.74.86-4.02.86zm3.24-2.66h2.96q1.4 0 2.42-.52a3.84 3.84 0 0 0 1.6-1.52q.58-.98.58-2.3 0-1.34-.58-2.3a3.7 3.7 0 0 0-1.6-1.5q-1.02-.54-2.42-.54h-2.96zm11.248 2.66 6.24-14h3.2l6.26 14h-3.4l-5.12-12.36h1.28l-5.14 12.36zm3.12-3 .86-2.46h7.2l.88 2.46zm16.229 3v-11.36h-4.48V211h12.2v2.64h-4.48V225zm6.92 0 6.24-14h3.2l6.26 14h-3.4l-5.12-12.36h1.28l-5.14 12.36zm3.12-3 .86-2.46h7.2l.88 2.46z"
    }, null, -1)
  ]))]))
}
export default { render: render }